import { useState } from "react";
import modalclose from "../images/modalclose.svg";
import userForm from "../images/userForm.svg";
import lock from "../images/lock.svg";
import eye from "../images/eye.svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoginMutation } from "../store/apis";
import {
  closeLoginModal,
  loginFailure,
  loginSuccess,
  openRegisterModal,
  selectLoginModal,
  setLoginModal,
  setRegisterModal,
  setResetPasswordModal,
} from "../store/auth-slice";
import { API_URL } from "../constants";
import { handleApiError } from "../errors";

const Login = ({ isOpen, onClose }) => {
  const loginModalOpen = useSelector(selectLoginModal);
  const dispatch = useDispatch();
  const [login, { isLoading }] = useLoginMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    phone: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    phone: "",
    password: "",
  });
  const navigate = useNavigate();
  if (!isOpen && !loginModalOpen) return null;
  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      phone: "",
      password: "",
    };

    // Phone validation
    const phoneRegex = /^[17]\d{0,8}$/;
    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
      isValid = false;
    } else if (formData.phone.length > 9) {
      newErrors.phone = "Phone number must have 9 characters";
      isValid = false;
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "Phone number must start with 7 or 1";
      isValid = false;
    }
    // else if (!phoneRegex.test(formData.phone)) {
    //   newErrors.phone = "Please enter a valid 10-digit phone number";
    //   isValid = false;
    // }

    // Password validation
    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
    // Clear error when user starts typing
    if (errors[id]) {
      setErrors((prev) => ({
        ...prev,
        [id]: "",
      }));
    }
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validateForm()) {
  //     return;
  //   }

  //   try {
  //     const response = await fetch(`${API_URL}/signin`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: "secret",
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         username: formData.phone, // API expects 'username' instead of 'phone'
  //         password: formData.password,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (data.status === "success") {
  //       dispatch(loginSuccess({ token: data.token }));
  //       onClose();
  //     } else {
  //       dispatch(loginFailure(data.message || "Login failed"));
  //       setErrors({
  //         general: data.message || "Login failed. Please try again.",
  //       });
  //     }
  //   } catch (error) {
  //     dispatch(loginFailure("Network error or server unavailable"));
  //     setErrors({
  //       general: "Network error or server unavailable. Please try again.",
  //     });
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const response = await login({
        username: `254${formData.phone}`,
        password: formData.password,
      }).unwrap();

      const redirectUrl = sessionStorage.getItem("redirectUrl");
      if (redirectUrl) {
        sessionStorage.removeItem("redirectUrl");
        navigate(redirectUrl);
      }

      // dispatch(setUser(response.user));
      dispatch(
        loginSuccess({
          accessToken: response.accessToken,
          refreshToken: response.refreshToken,
          user: response.user,
        })
      );
      onClose();
    } catch (error) {
      // Handle API errors
      setErrors((prev) => ({
        ...prev,
        general: error.data?.message || "Login failed. Please try again.",
      }));
      handleApiError(error, {
        setErrors, // This will set form errors
        showToast: true, // Show toast notification
        onAuthError: () => {
          // Handle authentication errors specifically
          // For example, you might want to clear user state
          // dispatch(logout());
        },
      });
    }
  };
  const openRegisterModalHandler = (e) => {
    // console.log("cakkerea");
    e.preventDefault();
    dispatch(setRegisterModal(true));
    dispatch(setLoginModal(false));
  };
  const openResetPassModal = () => {
    dispatch(setResetPasswordModal(true));
    dispatch(setLoginModal(false));
  };
  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
      role="dialog"
      aria-modal="true"
    >
      <div className="h-full w-full overflow-y-auto flex justify-center items-center">
        <div
          className="relative w-full max-w-[541px] animate-fade-in"
          tabIndex={0}
        >
          <div className="px-[15px]">
            <div className="bg-[#F4F7F9] p-[20px_16px] s16:p-[32px_30px] rounded-[20px] relative overflow-auto">
              <div className="flex justify-between items-center pb-[10px] mb-5 s16:mb-[30px] border-b-[1px] border-black/15">
                <h4 className="text-darkblue text-xl s16:text-2xl font-medium">
                  Login
                </h4>
                <button
                  onClick={onClose}
                  className="w-[38px] h-[38px] min-w-[38px] flex justify-center items-center border-[1px] rounded-md border-[rgba(0, 0, 0, 0.20)] bg-[rgba(0, 0, 0, 0.05)] hover:bg-gray-300 transition-all duration-[0.4s]"
                >
                  <img src={modalclose} alt="close" />
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                {errors.general && (
                  <div className="mb-4 p-2 text-red-600 bg-red-100 rounded">
                    {errors.general}
                  </div>
                )}
                {/* Modal Content */}
                <div className="space-y-5">
                  {/* Phone Number Input */}
                  <div className="flex flex-col">
                    <label
                      htmlFor="phone"
                      className="text-sm s15:text-base s18:text-lg font-normal text-[#374151] !leading-none mb-2 s15:mb-[10px]"
                    >
                      Phone Number
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        id="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="7xxxxxxxx"
                        className="block w-full py-2 pl-[84px] pr-12 s18:pl-[84px] s18:p-[13px_52px_13px_84px] bg-[#0000000c] border border-[#00000033] rounded-md focus:outline-none !leading-normal s18:!leading-normal s18:text-dark text-base s18:text-lg font-normal placeholder:text-[#9599A1] placeholder:text-base s18:placeholder:text-lg"
                      />
                      {/* User icon with vertical line */}
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <div className="flex items-center">
                          <img
                            src={userForm}
                            alt="user"
                            className="object-contain w-3 xl:w-4 s16:w-4 mr-2"
                          />
                          <span className="text-darkblue">+254</span>
                          <div className="h-[18px] w-[1px] bg-black/20 mx-2"></div>
                        </div>
                      </div>
                    </div>
                    {errors.phone && (
                      <p className="mt-1 text-red-500 text-sm">
                        {errors.phone}
                      </p>
                    )}
                  </div>

                  {/* Password Input */}
                  <div className="flex flex-col">
                    <label
                      htmlFor="password"
                      className="text-sm s15:text-base s18:text-lg font-normal text-[#374151] !leading-none mb-2 s15:mb-[10px]"
                    >
                      Password
                    </label>
                    <div className="relative after:absolute after:top-1/2 after:-translate-y-1/2 after:w-[1px] after:h-[18px] after:left-[38px] s18:after:left-[41px]  after:content-[''] after:bg-black/20">
                      <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="Password"
                        className="block w-full py-2 px-12 s18:p-[13px_52px_13px_52px] bg-[#0000000c] border border-[#00000033] rounded-md focus:outline-none !leading-normal s18:!leading-none text-dark text-base s18:text-lg  font-normal placeholder:text-[#9599A1]"
                      />
                      <span className="absolute inset-y-0 left-0 pl-3 pr-[10px]  flex items-center pointer-events-none">
                        <img
                          src={lock}
                          alt="lock"
                          className="object-contain w-3 xl:w-4 s16:w-4"
                        />
                      </span>
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute top-1/2 -translate-y-1/2 right-[10px]"
                      >
                        <img
                          src={eye}
                          alt="toggle password visibility"
                          className="object-contain w-3 xl:w-4 s16:w-4"
                        />
                      </button>
                    </div>
                    {errors.password && (
                      <p className="mt-1 text-red-500 text-sm">
                        {errors.password}
                      </p>
                    )}
                  </div>

                  {/* Links */}
                  <div className="flex max-[427px]:gap-3 justify-between gap-[30px]">
                    <Link
                      to="/"
                      onClick={openResetPassModal}
                      className="text-[#9599A1] hover:text-darkblue max-[427px]:text-sm text-lg font-normal !leading-none transition-all duration-300 underline"
                    >
                      Forgot Password?
                    </Link>
                    <Link
                      to="/"
                      className="text-[#9599A1] hover:text-darkblue max-[427px]:text-sm text-lg font-normal !leading-none transition-all duration-300 underline"
                    >
                      Activate Account?
                    </Link>
                  </div>
                  {/* Buttons */}
                  <div className="flex space-x-[10px]">
                    <button
                      type="submit"
                      className="w-full max-w-[349px] hover:bg-yellow/70 !leading-none p-[17px_17px] bg-yellow text-darkblue rounded-md font-medium"
                    >
                      {isLoading ? "LOGIN..." : "LOGIN"}
                    </button>
                    <button
                      onClick={openRegisterModalHandler}
                      className="w-full max-w-[92px] hover:bg-darkblue/70 !leading-none p-[17px_17px] bg-darkblue text-yellow rounded-md font-medium"
                    >
                      REGISTER
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
